import { SelectedDeliveryOption } from "../types";
import { CPTSlabForManualOption } from "../../../views/Orders/enums";
import { formatMinInstantDeliveryChargeMessage } from "../../../constants/logisticsCptSlabs";

export interface ValidationConfig {
  instantDeliveryMinimumDeliveryCost?: number;
}

export interface ValidationError {
  id: string;
  message: string;
  targetField?: "deliveryCharge" | "cpt" | "cptSlab" | "general";
}

export interface ValidationResult {
  isValid: boolean;
  errors: ValidationError[];
  errorsByField: Record<string, ValidationError[]>;
}

export interface DeliverySelectionValidationRule {
  id: string;
  targetField?: "deliveryCharge" | "cpt" | "cptSlab" | "general";

  shouldApply: (
    selection: SelectedDeliveryOption,
    config: ValidationConfig,
  ) => boolean;

  validate: (
    selection: SelectedDeliveryOption,
    config: ValidationConfig,
  ) => boolean;

  getErrorMessage: (
    selection: SelectedDeliveryOption,
    config: ValidationConfig,
  ) => string;
}

export const DELIVERY_SELECTION_VALIDATION_RULES: DeliverySelectionValidationRule[] =
  [
    {
      id: "manual-instant-delivery-min-delivery-charge",
      targetField: "deliveryCharge",
      shouldApply: (selection) =>
        selection.deliveryDetails?.selectionType === "manual" &&
        selection.deliveryDetails?.manualEntry?.cptSlab ===
          CPTSlabForManualOption.INSTANT_DELIVERY,
      validate: (selection, config) => {
        const charge = selection.deliveryDetails?.manualEntry?.deliveryCharge;
        const minCharge = config.instantDeliveryMinimumDeliveryCost ?? 50;
        return charge !== undefined && charge !== null && charge >= minCharge;
      },
      getErrorMessage: (selection, config) => {
        const minCharge = config.instantDeliveryMinimumDeliveryCost ?? 50;
        return formatMinInstantDeliveryChargeMessage(minCharge);
      },
    },
  ];
